import {LanguageShortCodeType} from "./types/language-short-code.type.ts";

const hash = (length = 10) => [...Array(length)].map(() => (~~(Math.random() * 36)).toString(36)).join('')

const on = (
	event: string,
	entity: any,
	method: string,
	param: unknown = null
) => {
	let name
	do {
		name = `${method}_${hash(10)}`
	} while(window[name] !== undefined)

	// @ts-ignore
	window[name] = (e,v) => {
		e.preventDefault()
		e.stopPropagation()
		entity[method].call(entity, e, v, param)
	}

	return `on${event}="window.${name}(event,this)"`
}

const bind = (
	entity: any,
	attribute: string,
	callbacks: (() => void)[] = []
) => {
	if(typeof callbacks === 'string') callbacks = [callbacks]

	let name
	do {
		name = `bind_${hash(10)}`
	} while(window[name] !== undefined)

	// @ts-ignore
	window[name] = e => {
		entity[attribute] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
		callbacks.map(callback => entity[callback].call(entity))
	}

	return `onchange="window.${name}(event)" value="${entity[attribute]}"`
}

const getCurrentLang = (): LanguageShortCodeType | null => {
	const hasCookiesMatch = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)')
	const activeLang = hasCookiesMatch ? hasCookiesMatch[2].split('/')[2] : null
	return activeLang as LanguageShortCodeType | null
}

export {
	on,
	bind,
	hash,
	getCurrentLang
}
